export default __webpack_public_path__ + "static/media/SLIDE_CAMELLON_5.431af131.jpg";